import get from 'lodash/get';
import includes from 'lodash/includes';

function transformDeliveries(action) {

  const orderForm = get(action, 'result.orderForm', {});
  const deliveries = get(orderForm, 'deliveries', []);
  const items = get(orderForm, 'items', []);

  return deliveries.map((delivery) => {
    const deliveryItems = items.filter(item => includes(delivery.itemIds, item.id));

    return {
      ...delivery,
      items: deliveryItems,
    };
  });
}

export default transformDeliveries;
